import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { ToastNotificationService } from '../../servicios/toast-notification.service';
import { Router } from '@angular/router';
import { AtributosService } from '../../servicios/atributos.service';
import { AppUtilService } from '../../servicios/app.util.service';
import { HashKeyServices } from '../../servicios/app.hashkey.services';
import { nkServices } from '../../servicios/app.nkservicios.services';
import { FormmMsgComponent } from '../formm-msg/formm-msg.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-form-pasarela',
  templateUrl: './form-pasarela.component.html',
  styleUrls: ['./form-pasarela.component.css']
})
export class FormPasarelaComponent implements OnInit {
  data_usuario:any;
  data_total:any;
  data_productos:any = [];
  card:any;
  stripe: Stripe;
  cod_tdc: any;
	cod_fecha: any;
	cod_cvc: any;
  monto:any;
  metodo:any;
  pasarela:any;
  stripe_1:any;
  paypal_1:any;
  key:any;
  tipo_cat:any;
  forma:any;
  constructor(
            private servicio:nkServices,
            private fb:FormBuilder,
            private dialog: MatDialog,
            private hashkey:HashKeyServices,
            private util:AppUtilService,
            private atrb:AtributosService,
            private router:Router,
            private notifi:ToastNotificationService,
            private dialogRef: MatDialogRef<FormPasarelaComponent>,
            ///en el injectable llega la informacion del metodo padre en data
            @Inject(MAT_DIALOG_DATA) private data: any
  ) { 
    console.log(data, 'primero');
    this.stripe_1 = this.atrb.OPERACIONALES.stripe.toUpperCase();
    this.paypal_1 = this.atrb.OPERACIONALES.paypal.toUpperCase();
    this.monto = data.membresia;
    let forma_pago;
    let forma_key;
    this.pasarela = data.tipo.toUpperCase();
    for (const i in data.pasarela) {
      forma_pago = data.pasarela[i].tipo_cat.split('-');
      if (forma_pago[0].toUpperCase() === this.pasarela) {
            data.pasarela[i].val_cat = this.hashkey.decrypt(data.pasarela[i].val_cat);
            forma_key = data.pasarela[i].val_cat.split(',');
            this.metodo = forma_pago[0].toUpperCase();
            this.key = forma_key[0];
            this.tipo_cat = data.pasarela[i].tipo_cat;
      }
    }
    let tipo_cat = this.tipo_cat.split('-');
    if (tipo_cat[0].toUpperCase() === this.atrb.OPERACIONALES.stripe.toUpperCase()) {
      this.forma = this.fb.group({
        numero: [''],
        direccion: [''],
        cardCvc: [false, [Validators.required, Validators.requiredTrue]],
        cardExp: [false, [Validators.required, Validators.requiredTrue]],
        cardNumber: [false, [Validators.required, Validators.requiredTrue]],
      });
     }
     if (tipo_cat[0].toUpperCase() === this.atrb.OPERACIONALES.paypal.toUpperCase()) {
            this.forma = this.fb.group({
              des_usuario: ['', [Validators.required]],
              des_correo: ['', [Validators.required]],
            });
     }
  }
  async ngOnInit() {
    /* await  this.tdcActiva(); */
     this.card = true;
      /* await this.cargarElementStripe(); */
    }
  async ngAfterViewInit() {
    /* await  this.tdcActiva(); */
      await this.cargarElementStripe();
    }
  async cargarElementStripe(){
      try {
        await this.util.abrirSpinner();
        const card1 = document.querySelector('#card-2') as HTMLDivElement;
      if (card1) {
        this.stripe = await loadStripe(this.key);
        const elements = this.stripe.elements();
        const style = {
          base: {
            iconColor: '#0ccde4',
            fontSize: '20px',
            color:'#212529',
          },
          invalid: {
            color: '#dc3545',
          },
        };
        const cardNumber = elements.create('cardNumber', {
          style,
          placeholder: 'tdc',
          classes: {
            base: 'input-excep',
          },
        });
        const cardExpiry = elements.create('cardExpiry', {
          style,
          placeholder: 'exp',
          classes: {
            base: 'input-excep',
          },
        });
        const cardCvc = elements.create('cardCvc', {
          style,
          placeholder: 'cvc',
          classes: {
            base: 'input-excep',
          },
        });
        cardNumber.mount('#card-2');
        cardExpiry.mount('#exp-1');
        cardCvc.mount('#cvc-1');
        this.cod_tdc = cardNumber;
        this.cod_fecha = cardExpiry;
        this.cod_cvc = cardCvc;
        this.cod_tdc.on('change', this.onChangeCard.bind(this));
        this.cod_fecha.addEventListener('change', this.onChangeCvc.bind(this));
        this.cod_cvc.on('change', this.onChangeExp.bind(this));
        await this.util.cerrarSpinner();
      }else{
        await this.util.cerrarSpinner();
      }
      } catch (error) {
        await this.util.cerrarSpinner();
        console.log(error);
      }
    }
    async  modalrespuesta(){
      try {
        var accion2 = '';
        var dialogRefp = this.dialog.open(FormmMsgComponent, {
          width: '100vw',
          maxWidth: '100vw',
          height:'auto',
          data: {id:this.data.id_cliente,
                accion:accion2},
          disableClose: true,
          panelClass: 'pedidos_modal',
          backdropClass: "bdrop"
        });
        dialogRefp.afterClosed().subscribe(async result => {
          await this.util.abrirSpinner();
          if(result !== await this.atrb.CERRAR){
            let tipo_cat = this.tipo_cat.split('-');
              await this.util.cerrarSpinner();
              if (tipo_cat[0].toUpperCase() === await this.atrb.OPERACIONALES.stripe.toUpperCase()) {
               await this.enviarStripe(result);
              }
              if (tipo_cat[0].toUpperCase() === await this.atrb.OPERACIONALES.paypal.toUpperCase()) {
                await this.enviarPaypal(result);
              }
          }else{
            await this.util.cerrarSpinner();
          }
        });
      } catch (error) {
        await this.util.cerrarSpinner();
        await this.notifi.customToastNotification(error.error.message);
      }
    }
    async enviarStripe(xvalor:any) {
      try {
        await this.util.abrirSpinner();
      const { token } = await this.stripe.createToken(this.cod_tdc);
      console.log(token);
      if (token) {
        let xvalor = {
          amount: parseFloat(await this.util.remplazo_coma_punto(this.monto )),
          currency:'usd',
          token:token.id,
          tipo_cat:this.tipo_cat,
          cod_app : await this.hashkey.encrypt(environment.path_token),
          cod_empresa : await localStorage.getItem('cod_empresa'),
          api: await this.hashkey.encrypt(await this.atrb.API_REST.gestionPasarela)
        }
       const response =  await this.servicio.ApiResthttp(xvalor).toPromise();
        await this.util.cerrarSpinner();
        await this.notifi.success(response.message);
        this.dialogRef.close(await this.atrb.CERRAR);
      }else{
        await this.util.cerrarSpinner();
        await this.notifi.success('Pago rechazado...');
      }
      } catch (error) {
        await this.util.cerrarSpinner();
        console.log(error);
      }
    }
    async enviarPaypal(xvalor:any) {
      try {
        await this.util.abrirSpinner();
        let xvalor = {
          amount: parseFloat(await this.util.remplazo_coma_punto(this.monto )),
          currency:'usd',
          token:'',
          tipo_cat:this.tipo_cat,
          des_correo:this.forma.value.des_correo,
          des_usuario:this.forma.value.des_usuario,
          cod_app : await this.hashkey.encrypt(environment.path_token),
          cod_empresa : await localStorage.getItem('cod_empresa'),
          api: await this.hashkey.encrypt(await this.atrb.API_REST.gestionPasarela)
        }
       const response =  await this.servicio.ApiResthttp(xvalor).toPromise();
        await this.util.cerrarSpinner();
        await this.notifi.success(response.message);
        this.dialogRef.close(await this.atrb.PROCESO);
      } catch (error) {
        await this.util.cerrarSpinner();
        console.log(error);
        await this.notifi.customToastNotification(error.error.message);
      }
    }
    async cerrarmodal(){
      try {
        let accion = 'salir';
        let dialogRefp = this.dialog.open(FormmMsgComponent, {
          width: '100vw',
          maxWidth: '100vw',
          height:'auto',
          data: {id:'',
                accion:accion},
          disableClose: true,
          panelClass: 'pedidos_modal',
          backdropClass: "bdrop"
        });
        dialogRefp.afterClosed().subscribe(async result => {
          await this.util.abrirSpinner();
          if (result !== await this.atrb.CERRAR) {
            await this.util.cerrarSpinner();
            this.dialogRef.close(await this.atrb.CERRAR);
          }else{
            await this.util.cerrarSpinner();
          }
        });
      } catch (error) {
        console.log(error);
     }
    }
  
    onChangeCard({ error }: any) {
      console.log(error, this.forma);
      this.forma.patchValue({ cardNumber: !error });
    }
    onChangeCvc({ error }: any) {
      console.log(error, this.forma);
      this.forma.patchValue({ cardCvc: !error });
    }
    onChangeExp({ error }: any) {
      console.log(error, this.forma);
      this.forma.patchValue({ cardExp: !error });
    }
  
}
